import { Tab } from "@headlessui/react";
import cls from "classnames";
import { format } from "date-fns";
import { useState } from "react";
import EmptyTab from "./EmptyTab";

const Testimonial = ({ post }) => {
  const quoteColors = ["#86894E", "#874C6B", "#5F538C", "#896755", "#4A8984"];
  return (
    <li className="relative mb-[22px] px-3 py-4 lg:p-5 last:mb-0 rounded-2xl bg-[#22262A] overflow-hidden">
      <div className="flex">
        <div className="mr-3 bg-transparent">
          <svg
            width={28}
            height={28}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.736 8.144l.938-.188V4.667h-1.166c-3.248 0-5.724.9-7.36 2.674-2.203 2.39-1.982 5.458-1.975 5.493v9.333a1.167 1.167 0 001.167 1.167h8.167A2.336 2.336 0 0019.84 21v-8.166a1.167 1.167 0 00-1.167-1.167h-4.758a3.385 3.385 0 01.5-1.629c.594-.934 1.71-1.571 3.322-1.894z"
              fill={quoteColors[Math.floor(Math.random() * quoteColors.length)]}
            />
          </svg>
        </div>
        <div className="w-full mt-3">
          <h3 className="italic text-[#B8B8B8] text-[11px] leading-[17px]">
            in {post?.channel_name}
          </h3>
          <p className="w-full pr-12 mt-2 break-words whitespace-pre-wrap sm:pr-0">
            {post.review}
          </p>
        </div>
      </div>
      <div className="flex items-center mt-7 lg:mt-8">
        {post.user?.avatar?.url ? (
          <img
            src={post.user?.avatar?.url}
            alt={post.user.fullname}
            className="w-8 h-8 mr-2 rounded-full"
          />
        ) : (
          <div className="w-8 h-8 text-base font-semibold border-none rounded-full color-white bg-white/[0.07] flex items-center justify-center mr-2">
            {(post?.user?.fullname || post?.user?.username)[0].toUpperCase()}
          </div>
        )}
        <div>
          <h4 className="text-[13px] font-semibold">{post.user.fullname}</h4>
          <p className="mt-[2px] text-xs text-[#A6A6A6] leading-[18px]">
            {format(new Date(post.created_at), "MMM dd")}
          </p>
        </div>
      </div>
    </li>
  );
};

export default function TestimonialsTab({ testimonials }) {
  const [pointer, setPointer] = useState(3);

  return (
    <>
      <Tab.Panel
        key={"Testimonials"}
        className={cls(
          "sm:w-[550px] bg-transparent pt-8 lg:pt-10 px-5 lg:px-0 text-left mx-auto",
          "focus:outline-none"
        )}
      >
        {testimonials?.length > 0 ? (
          <>
            <ul>
              {testimonials.slice(0, pointer).map((post, index) => (
                <Testimonial post={post} key={index} />
              ))}
            </ul>
            {pointer < testimonials.length && (
              <div className="text-center max-h-[21px] mt-5 lg:mt-8">
                <button
                  onClick={() => {
                    setPointer(pointer + 3);
                  }}
                  className="font-inter text-[#58A6EE] text-xs lg:text-sm leading-[18px] hover:opacity-90"
                >
                  Show more
                </button>
              </div>
            )}
          </>
        ) : (
          <EmptyTab tabName="testimonials" />
        )}
      </Tab.Panel>
    </>
  );
}
